<template>
  <div class="bg-w ">

    <div class="pl-20 pt-20 pr-20">
      <div class="flex a-center flex-wrap">
        <div class="flex a-center mr-20 mb-20">
          <div>账单月份：</div>
          <div><a-range-picker :value="time" :mode="mode" class="w-200" @panelChange="handlePanelChange" /></div>
        </div>

        <div class="flex a-center mr-20 mb-20">
          <a-button type="primary" @click="getList(true)">查 询</a-button>
        </div>
      </div>
    </div>
    <div class="pd-20">
      <a-table :columns="columns" :row-key="getKey" :data-source="list" :pagination="pagination" @change="handleTableChange">
        <div slot="beginTime" slot-scope="row">
          {{ $moment(row.beginTime).format('YYYY年MM月') }}
        </div>

        <div slot="action" slot-scope="row">
          <span class="f-c-blue pointer" @click="showDetail(row)">账单明细</span>
          <span class="f-c-blue pointer" @click="exp(row)">导出Excel</span>
        </div>
      </a-table>
    </div>
    <billDetail :cust-bill-code="custBillCode" :visible.sync="visible" />
  </div>
</template>
<script>
import billDetail from './billDetail'
const columns = [
  { title: '账单月份', key: 'beginTime', scopedSlots: { customRender: 'beginTime' }},
  { title: '订单数', key: 'orderNumber', dataIndex: 'orderNumber' },
  { title: '运费金额（元）', dataIndex: 'freightAmount', key: 'freightAmount' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
]

export default {
  components: {
    billDetail
  },

  data() {
    return {
      custBillCode: '',
      visible: false,
      visible1: false,
      addressType: {
        1: '寄件',
        2: '收件'
      },
      columns,
      mode: ['month', 'month'],
      params: {
        'endTime': '',
        'pageIndex': 1,
        'pageSize': 20,
        'startTime': ''
      },
      list: [],
      loading: false,
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      },
      time: null
      // companys: []
    }
  },
  watch: {
    time(n) {
      console.log('nnnnnnnnnnnnnnnnnnn', n)
      if (n) {
        this.params.startTime = n[0].startOf('month').format('YYYY-MM-DD')
        this.params.endTime = n[1].startOf('month').format('YYYY-MM-DD')
      } else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
    }
  },
  async created() {
    const res = await this.$http(this.$api.logisticsGetList)
    this.companys = res || []
    this.getList()
  },
  methods: {
    handlePanelChange(value, mode) {
      this.time = value
      this.mode = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]
    },
    async exp(row) {
      const p = {
        custBillCode: row.billCode
      }
      Object.assign(p, this.params)
      this.$down(this.$api.customerBillExportCustomerBillDetail, p)
    },
    showDetail(row) {
      this.custBillCode = row.billCode
      this.visible = true
    },
    getKey(row) {
      return JSON.stringify(row)
    },
    async handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    },
    async getList(isRest) {
      if (isRest) {
        this.pagination.current = 1
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.customerBillGetCustomerBill, { ...this.params })
      if (res) {
        this.list = res.list || []
        this.pagination.current = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.total = res.totalSize
      }
    }
  }
}
</script>
